// extracted by mini-css-extract-plugin
export default {"circle_background":"CircularProgressBar_circle_background__jneAK","circle_progress":"CircularProgressBar_circle_progress__W1hGu"};